import { createContext, useContext, useEffect, useState } from "react";
import { en } from "@/i18n/en";
import { hi } from "@/i18n/hi";

const LangContext = createContext(null);
const DICTS = { en, hi };

export function LanguageProvider({ children }) {
  const [lang, setLangState] = useState(() => {
    try {
      const saved = localStorage.getItem("kazims-lang");
      return saved === "hi" ? "hi" : "en";
    } catch {
      return "en";
    }
  });

  const setLang = (l) => {
    setLangState(l);
    try {
      localStorage.setItem("kazims-lang", l);
    } catch {
      /* storage unavailable */
    }
  };

  useEffect(() => {
    document.documentElement.lang = lang === "hi" ? "hi" : "en";
  }, [lang]);

  const t = DICTS[lang] || en;
  return (
    <LangContext.Provider value={{ lang, setLang, t, isHi: lang === "hi" }}>
      {children}
    </LangContext.Provider>
  );
}

export const useLanguage = () => useContext(LangContext);
